var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeFill1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9903 24.6C14.7739 24.6 14.5566 24.5624 14.3383 24.4871C14.12 24.4119 13.928 24.294 13.7621 24.1335L12.3105 22.8561C10.5187 21.2745 8.91907 19.7208 7.51145 18.1951C6.10383 16.6693 5.40002 15.0348 5.40002 13.2914C5.40002 11.903 5.88359 10.7407 6.85071 9.80443C7.81784 8.86816 9.01848 8.40002 10.4526 8.40002C11.2675 8.40002 12.0724 8.58189 12.8672 8.94562C13.662 9.30934 14.373 9.90008 15 10.7178C15.6271 9.90008 16.338 9.30934 17.1328 8.94562C17.9277 8.58189 18.7325 8.40002 19.5474 8.40002C20.9816 8.40002 22.1822 8.86816 23.1493 9.80443C24.1165 10.7407 24.6 11.903 24.6 13.2914C24.6 15.0536 23.8842 16.7063 22.4527 18.2496C21.0211 19.793 19.4249 21.3334 17.6643 22.8711L16.2282 24.1335C16.0624 24.294 15.8687 24.4119 15.6471 24.4871C15.4256 24.5624 15.2067 24.6 14.9903 24.6Z",
    fill: "#FF7F1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFill1);
export default __webpack_public_path__ + "static/media/Like -Fill 1.5166adc28b19457a702ab11e6e0055ff.svg";
export { ForwardRef as ReactComponent };